import type { Game } from "@/domain/types";
import { SC2_CATEGORIES, SC2_CATEGORY_GROUPS } from "./parser/profile";

/**
 * StarCraft II - the contextual built-in Game. Its Profiles are SC2 sources ingested
 * into character-space Profiles (ingestSC2), each carrying the command-card Context tree; resolution
 * flows through the one generic projector like every Game. The `profiles` array stays empty here:
 * the selectable sources are SC2_SOURCES (platform/catalog/sc2-sources - catalog Presets, the
 * Blizzard stock presets, Edennil, uploads), composed by platform and built into Profiles by the
 * page, since they are dynamic (catalog-driven, with Preset routes the static array lacks).
 * Categories and grouping are SC2's curated taxonomy; its bespoke command-card Context tree lives in
 * the SC2 registry, so `contexts` (the flat-axis declaration) stays absent.
 */
export const sc2: Game = {
  id: "sc2",
  name: "StarCraft II",
  categories: SC2_CATEGORIES,
  groups: SC2_CATEGORY_GROUPS,
  profiles: [],
  // SC2 uploads ride the Source model (not ingestUpload), but the Profile picker still shows an
  // upload button, so SC2 declares how its export presents: a .SC2Hotkeys text file.
  uploadFormat: {
    accept: ".SC2Hotkeys,.txt,text/plain",
    fileLabel: ".SC2Hotkeys file",
    pasteLabel: ".SC2Hotkeys",
  },
};
